<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/XhZgQj/html/images/1_1.png?1700268171338" alt="This image is the cover for the book Great Sacrifice, The North's Civil War"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Great Sacrifice, The North's Civil War
      </h1>
      <p class="bookDescription body article font2">
        <b>“Offers readers new insight into the lives of African American men and women from the North in the era of the Civil War.” —Liz Regosin, Charles A. Dana Professor of History, St. Lawrence University</b><br/><br/><i>A Great Sacrifice </i>is an in-depth analysis of the effects of the Civil War on northern black families carried out using letters from northern black women—mothers, wives, sisters, and female family friends—addressed to a number of Union military officials.<br/><br/>Collectively, the letters give a voice to the black family members left on the northern homefront. Through their explanations and requests, readers obtain a greater apprehension of the struggles African American families faced during the war, and their conditions as the war progressed. The original letters that were received by government agencies, as well as many of the copies of the letters sent in response, are held by the National Archives in Washington, D.C.<br/><br/>This study is unique because it examines the effects of the war specifically on northern black families. Most other studies on African Americans during the Civil War focused almost exclusively on the soldiers.<br/><br/><b>“In this deeply researched and revealing book, James G. Mendez seeks to recover the experience of northern black soldiers and their families during the Civil War era in order to discover the ways they engaged the governments of their day both to recognize and respect their service and sacrifice during the war and to count the costs northern blacks paid out in impoverished families, wartime casualties, and unfulfilled promises . . . Mendez’s book deserves our attention and appreciation.” —<i>American Historical Review</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        James G. Mendez
      </h2>
      
      <p class="authorDescription body article"><B>James G. Mendez</B> is Associate Dean of Student Affairs and an Assistant Professor in the Department of Medical Education at Loyola University Chicago Stritch School of Medicine.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Fordham University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?9ed88d86